import React from 'react';

const DashboardLayout = ({ children }) => {
  return (
    <div className="operations-dashboard-layout">
      {children}
    </div>
  );
};

export default DashboardLayout;
